export enum Themes {
  DARK = 'dark',
  LIGHT = 'light',
  DEFAULT = 'default',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  WARNING = 'warning',
  INFO = 'info',
  ALERT = 'alert'
}
